export const VD_ORDER_FOR_STORAGE_KEY = "vd_order_for";

// Read + consume in one shot so the value cannot leak into a later purchase in this tab.
export const consumeVdOrderFor = (): string | undefined => {
  try {
    const orderFor = sessionStorage.getItem(VD_ORDER_FOR_STORAGE_KEY) || undefined;
    sessionStorage.removeItem(VD_ORDER_FOR_STORAGE_KEY);
    return orderFor;
  } catch {
    // sessionStorage may be unavailable (SSR / private mode); ignore.
    return undefined;
  }
};
